import { useMemo } from 'react';
import { usePermissionCheck } from './usePermissionCheck';
import type { TodoViewer } from '../lib/todos';

/**
 * Who the current user is for Tasks scoping. Null while permissions load so
 * callers can hold off queries instead of flashing an empty world.
 */
export function useTodoViewer(): TodoViewer | null {
  const { currentResource, canViewAdminDashboard, isLoading } = usePermissionCheck();

  return useMemo(() => {
    if (isLoading) return null;
    return {
      resourceId: currentResource?.id || null,
      isAdmin: canViewAdminDashboard,
    };
  }, [isLoading, currentResource?.id, canViewAdminDashboard]);
}
